import * as types from '../mutation-types'

// state
export const state = {
  lastroute: {
    path : '',
    query : {},
    params : {},
  },
}

// getters
export const getters = {
  lastroute: state => state.lastroute,
}

// mutations
export const mutations = {
  [types.SET_LASTROUTE] (state, { from }) {
    state.lastroute.path = from.path;
    state.lastroute.query = from.query;
    state.lastroute.params = from.params;
  }
}

// actions
export const actions = {
  setLastPath ({ commit }, { from }) {
    commit(types.SET_LASTROUTE, { from })
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/router.js